export const PBTCreateCaseActionType = {
  CREATE_CASE_REQUEST: 'pbt/createCase/CREATE_CASE_REQUEST',
  CREATE_CASE_SUCCESS: 'pbt/createCase/CREATE_CASE_SUCCESS',
  CREATE_CASE_ERROR: 'pbt/createCase/CREATE_CASE_ERROR',
  CREATE_CASE_RESET: 'pbt/createCase/CREATE_CASE_RESET',
  BULK_CREATE_REQUEST: 'pbt/createCase/BULK_CREATE_REQUEST',
  BULK_CREATE_SUCCESS: 'pbt/createCase/BULK_CREATE_SUCCESS',
  BULK_CREATE_ERROR: 'pbt/createCase/BULK_CREATE_ERROR',
  EXCEL_UPLOAD_REQUEST: 'pbt/createCase/EXCEL_UPLOAD_REQUEST',
  EXCEL_UPLOAD_SUCCESS: 'pbt/createCase/EXCEL_UPLOAD_SUCCESS',
  EXCEL_UPLOAD_ERROR: 'pbt/createCase/EXCEL_UPLOAD_ERROR',
} as const;
